export const getUnSeenCounts = ({
  unSeenCounts,
  userProfileId
}: {
  unSeenCounts: Array<{ [key: string]: number }>;
  userProfileId: string;
}) => {
  const unseen = unSeenCounts;
  if (!Array.isArray(unseen)) {
    return unSeenCounts || 0;
  }

  const targetIdNormalized = userProfileId.replace(/-/g, '').toLowerCase();

  for (const entry of unseen) {
    for (const [key, value] of Object.entries(entry)) {
      const keyNormalized = key.replace(/-/g, '').toLowerCase();
      if (keyNormalized === targetIdNormalized) {
        return typeof value === 'number' ? value : 0;
      }
    }
  }

  return 0;
};
